import React from "react";

export const IconText = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15.8"
            height="15.8"
            viewBox="0 0 15.8 15.8"
        >
            <g id="type" transform="translate(-3.1 -3.1)">
                <path
                    id="Path_349"
                    data-name="Path 349"
                    d="M4,7V4H18V7"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
                <line
                    id="Line_53"
                    data-name="Line 53"
                    x2="6"
                    transform="translate(8 18)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
                <line
                    id="Line_54"
                    data-name="Line 54"
                    y2="14"
                    transform="translate(11 4)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
            </g>
        </svg>
    );
};
